import React from 'react';
import { Box, Checkbox, Typography, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import List from '@mui/material/List';

const listStyle = {
    width: '100%',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
        width: '5px',
        height: '5px',
        backgroundColor: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
        background: '#c1c1c1',
    }
};

export default function ParticipantPoPUpRow(props) {
    const { item, index, classes } = props;
    return (
        // <List sx={listStyle}>
        //     <ListItem disablePadding>
        //         <ListItemButton
        //             sx={{ padding: '3px 0' }}
        //             onClick={() => props.handleToggle(item)}
        //         >
        //             <ListItemIcon sx={{ height: '28px', minWidth: '28px' }}>
        //                 <Checkbox
        //                     inputProps={{
        //                         'aria-label': 'Participant',
        //                     }}
        //                     onChange={(event) => props.onCheckSelect(item.userID, index)}
        //                     value={item.userID}
        //                     sx={{ '& .MuiSvgIcon-root': { fontSize: 20 }, pl: '0px' }}
        //                 />
        //             </ListItemIcon>
        //             <ListItemText
        //                 sx={props.showRole ? { textAlign: 'left', flex: '0.3' } : { textAlign: 'left', flex: '1' }}
        //                 primary={
        //                     <>
        //                         <Typography variant='span' sx={{ alignItems: 'center', display: 'flex', fontSize: '15px' }}>
        //                             {item.name}&nbsp;
        //                         </Typography>

        //                         <Typography sx={{ fontSize: 0 }}>
        //                             <a href={`javascript: void(0)`} style={{ textDecoration: 'none', fontSize: '12px' }}>
        //                                 {item.email}
        //                             </a>
        //                         </Typography>     
        //                         <Typography>Admin</Typography>             
        //                     </>
        //                 }
        //                 secondary={
        //                     props.showRole && props.showRole ? (
        //                         <a href={`javascript: void(0)`} style={{ textDecoration: 'none', fontSize: '12px', wordBreak: 'break-word' }}>
        //                             {item.email}
        //                         </a>
        //                     ) : null
        //                 }

        //             />
        //             <Typography>Admin</Typography>
        //         </ListItemButton>
        //     </ListItem>
        // </List>
        <Box
            className={classes.cardRowContent}
            sx={{ m: 0, p: 0 }}
            onClick={() => props.handleToggle(item)}>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', flex: '0.05', justifyContent: 'center' }}>
                <Checkbox
                    inputProps={{
                        'aria-label': 'Participant',
                    }}
                    onChange={(event) => props.onCheckSelect(item.userID, index)}
                    value={item.userID}
                    sx={{ '& .MuiSvgIcon-root': { fontSize: 20 }, height: '28px', minWidth: '28px', padding: '9px 9px 9px 0px' }}
                />
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', flex: '0.95', justifyContent: 'left' }}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'left', flexDirection: 'column' }}>
                    <Box>
                        <Typography
                            variant="span"
                            flexGrow={1}
                            sx={{ alignItems: 'center', display: 'flex', fontSize: '15px', fontWeight: 700, color: '#394150' }}
                        >
                            {item.name}&nbsp;
                        </Typography>
                    </Box>
                    <Box>
                        <Typography
                            sx={{
                                wordBreak: 'break-word',
                                fontSize: 0
                            }}
                        >
                            <a
                                href={`javascript: void(0)`}
                                style={{ textDecoration: 'none', fontSize: '12px', fontWeight: 400 }}
                            >
                                {' '}
                                {item.email}{' '}
                            </a>
                        </Typography>
                        {item.userType && item.userType == "Admin" ? <Typography
                            fontSize={11} 
                            sx={{color:'red'}}
                        >
                            Admin
                        </Typography> : null}
                    </Box> 
                </Box>
            </Box>
        </Box>
    );
}
